import { render, staticRenderFns } from "./DrawerGiftDetail.vue?vue&type=template&id=6d640779&scoped=true&"
import script from "./DrawerGiftDetail.vue?vue&type=script&lang=js&"
export * from "./DrawerGiftDetail.vue?vue&type=script&lang=js&"
import style0 from "./DrawerGiftDetail.vue?vue&type=style&index=0&id=6d640779&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d640779",
  null
  
)

export default component.exports